import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Input, Button, Select, Row, Col, Form } from "antd";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { isEmpty } from "utils/isEmpty";
// import { CustomFormItem} from 'Components/Form/CustomFormItem';

interface ReproServiceFormProps extends WithTranslation, ModalComponentProps {
  onEdit: (obj: API_PrintJobProvider) => Promise<void>;
  onCreate: (obj: API_PrintJobProvider) => Promise<void>;
  initialData?: API_PrintJobProvider;
  projectName?: string;
  providers?: API_PrintJobProvider[];
}

interface ReproServiceFormState {
  loading: boolean;
}
// onValuesChange: (props: ReproServiceFormProps, values) => {
//   if (Object.keys(values).length > 0) {
//     props.setConfirmOnCancel(true);
//   } else {
//     props.setConfirmOnCancel(false);
//   }
// }
export const ReproServiceForm = withTranslation(I18N_NS.ADMIN)(
  class extends React.Component<ReproServiceFormProps, ReproServiceFormState> {
    static defaultProps: Pick<ReproServiceFormProps, "initialData"> = {
      initialData: {
        // display: 'TST',
        // email: 'test@test.mail',
        // id: 12,
        // name: 'test',
        // orderRemark: 'remark',
        // priority: 122
      },
    };
    readonly state: ReproServiceFormState = { loading: false };

    handleFinish = async (values) => {
      const { initialData } = this.props;
      try {
        this.setState({ loading: true });
        if (isEmpty(initialData)) {
          await this.props.onCreate(values);
        } else {
          await this.props.onEdit({ ...initialData, ...values });
        }
        this.props.setConfirmOnCancel(false);
        this.props.hideModal();
      } catch (error) {
        throw error;
      } finally {
        this.setState({ loading: false });
      }
    };

    render() {
      const { t, initialData } = this.props;
      const { loading } = this.state;
      return (
        <Form layout="vertical" onFinish={this.handleFinish} initialValues={initialData} requiredMark={false}>
          <Row justify="space-between" gutter={16}>
            {Object.prototype.hasOwnProperty.call(this.props.initialData.hasOwnProperty, "id") && (
              <>
                <Col xs={24} md={12}>
                  <Form.Item label={t("Project")} colon={true}>
                    {this.props.projectName}
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label={t("Repro ID")} colon={true}>
                    {initialData.id}
                  </Form.Item>
                </Col>
              </>
            )}
            <Col xs={24}>
              <Form.Item
                label={t("Repro service")}
                name="id"
                rules={[{ required: true, message: t("Please choose repro service") }]}
                colon={true}
              >
                <Select disabled={initialData.id ? true : false}>
                  {this.props.providers.map(({ id, name }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label={t("Priority")} name="priority" colon={true}>
                <Input />
              </Form.Item>
            </Col>
            {Object.prototype.hasOwnProperty.call(this.props.initialData, "id") && (
              <Col xs={24} md={18}>
                <Form.Item
                  label={t("Address")}
                  name="email"
                  rules={[{ required: true, message: t("Please indicate address") }]}
                  colon={true}
                >
                  <Input />
                </Form.Item>
              </Col>
            )}
            <Col xs={24} md={this.props.initialData.id ? 24 : 18}>
              <Form.Item
                label={t("Alternative display of service")}
                name="display"
                rules={[{ required: true, message: t("Please indicate alternative name to display") }]}
                colon={true}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item label={t("Print job remark")} name="orderRemark" colon={true}>
                <Input.TextArea style={{ border: "1px solid #e4e4e4", padding: "10px" }} />
              </Form.Item>
            </Col>
          </Row>
          <ButtonsRow justify="space-between">
            <Button onClick={this.props.hideModal}>{t("Cancel")}</Button>
            <Button type="primary" loading={loading} htmlType="submit">
              {t("Save")}
            </Button>
          </ButtonsRow>
        </Form>
      );
    }
  }
);
